import { createFileRoute } from '@tanstack/react-router';

import { OverviewPage } from '@/features/staff-commission';
import { currentPeriod } from '@/shared/lib/dates';

export const Route = createFileRoute('/_app/staff-commission/')({
  component: function StaffCommissionOverview() {
    const search = Route.useSearch();
    const navigate = Route.useNavigate();
    return (
      <OverviewPage
        period={search.period ?? currentPeriod()}
        staffType={search.staffType}
        onScopeChange={(patch) => void navigate({ search: (prev) => ({ ...prev, ...patch }) })}
      />
    );
  },
});
